/**
 * v4 budget progress-bar split (#1377, V4_ADDENDUM convention 6). Pure math so
 * it is property-testable without rendering.
 *
 * Normal (spent <= budgeted): a green fill consumes `fillPct` of a recessed
 * track. Over budget: the bar fills the whole track and splits
 * proportionally - green = budgeted share, amber = overspend share
 * ($1,000 budgeted + $100 over -> 90.9% green / 9.1% amber). The amber
 * segment renders at the LEFT origin (the same origin the spend fill grew
 * from), per the board.
 *
 * @param {number} budgetedCents  the funded amount (credits)
 * @param {number} spentCents     the spent amount (debits, positive number)
 * @returns {{ over: boolean, fillPct: number, greenPct: number, amberPct: number }}
 */
export const budgetBarSegments = (budgetedCents, spentCents) => {
  const budgeted = Math.max(0, Number(budgetedCents) || 0);
  const spent = Math.max(0, Number(spentCents) || 0);

  if (spent <= budgeted) {
    const fillPct = budgeted === 0 ? 0 : (spent / budgeted) * 100;
    return { over: false, fillPct, greenPct: fillPct, amberPct: 0 };
  }

  const greenPct = (budgeted / spent) * 100;
  return { over: true, fillPct: 100, greenPct, amberPct: 100 - greenPct };
};
